import { type ReactNode } from "react";
import { Edit3, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Menu, MenuTrigger, MenuPanel, MenuItem, MenuSeparator } from "../animate-ui/components/base/menu";

interface UserDropdownProps {
  children: ReactNode;
  onEditProfile: () => void;
  align?: "left" | "right" | "top";
}

export function UserDropdown({ children, onEditProfile, align = "left" }: UserDropdownProps) {
  const { logout } = useAuth();

  return (
    <Menu>
      <MenuTrigger>
        {children}
      </MenuTrigger>

      <MenuPanel align={align}>
        <MenuItem onClick={onEditProfile}>
          <Edit3 className="w-4 h-4" />
          Edit Profile
        </MenuItem>
        
        <MenuSeparator />
        
        <MenuItem variant="destructive" onClick={logout}>
          <LogOut className="w-4 h-4" />
          Log out
        </MenuItem>
      </MenuPanel>
    </Menu>
  );
}
